import { ReactComponent as Apple } from 'assets/icons/icon-apple.svg';

export default Apple;
